import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.comments;

export default class Comments extends Model {
  static entity = `${ name }`;

  static fields() {
    return {
      id: this.increment(1),
      author_id: this.number(null),
      module: this.string('GENERAL'),
      unique_id: this.string(''),
      role: this.string('PM'),
      text: this.attr(null),
      extra: this.attr({}),
      date_created: this.string(new Date().toISOString()),
      date_updated: this.string(new Date().toISOString()),
      trial: this.number(null),
      author: this.number(null),
      files_ids: this.attr([]),
      files: this.attr([]),
    };
  }

  get header() {
    return this.date_created.substr(0, 10);
  }

  get time() {
    return this.date_created.substr(11, 8);
  }

  get updateTime() {
    const date_updated = new Date(this.date_updated).getTime();
    const date_created = new Date(this.date_created).getTime();
    const delta = date_updated - date_created > 60000;
    return delta
      ? this.date_updated.substr(11, 8)
      : null;
  }

  static methodConf = {
    http: {
      url: '',
    },
    methods: {
      $fetch: {
        name: 'fetch',
        http: {
          url: '/:type/:id/comments?:query',
          method: 'get',
        },
      },
      $create: {
        name: 'create',
        http: {
          url: '/comments/',
          method: 'post',
        },
      },
      $delete: {
        name: 'delete',
        http: {
          url: '/comments/:id',
          method: 'delete',
        },
      },
      $update: {
        name: 'update',
        http: {
          url: '/comments/:id',
          method: 'patch',
        },
      },
    },
  };
}
